export const mobilenav = {
  closed: {
    opacity: 0,
    transition: { duration: 0.2 },
  },
  open: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const mobilenavButton = {
  closed: {
    opacity: 0,
    x: 100,
  },
  open: {
    opacity: 1,
    x: 0,
  },
};

export const mobilenavItem = {
  open: { opacity: 1 },
  closed: { opacity: 0 },
};
